import { client } from "../src/sanityClient"

export async function getRoutes() {
  return client.fetch(`
    *[_type == "route"] | order(id asc){
      _id,
      name,
      kms,
      hours,
      description,
      tempo,
      "mountain": elevation,
      "img": img.asset->url,
      sections[]{
        "img": image.asset->url,
        text
      }
    }
  `)
}